import { css } from 'lit';

export default css`
  .nile-progress-bar__container {
    width: 100%;
    margin: 0 auto;
  }

  .nile-progress-bar__progress-bar {
    width: 100%;
    counter-reset: step;
    padding: 0;
    margin: 0 auto;
    list-style: none;
    display: flex;
    height: 2px;
    justify-content: space-between;
  }

  .nile-progress-bar__progress-bar li {
    position: relative;
    width: 100%;
    height: 2px;
    background-color: var(--nile-colors-neutral-400);
  }

  .nile-progress-bar__progress-bar li.changeColor::after {
    background-color: var(--nile-colors-primary-600);
  }

  .nile-progress-bar__progress-bar li span {
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--nile-colors-primary-600);
    height: 2px;
    transition: all 1s linear;
  }

  .nile-progress-bar__reset {
    background-color: var(--nile-colors-neutral-400);
    position: absolute;
    z-index: 1;
  }
`;
